import { CDN, ENV } from '@/global.js';
export const _$eruda = (func, env) => {
    func = typeof func === 'function' ? func : function () {};
    try {
        if (new RegExp(env || 'test|staging|development', 'i').test(ENV)) {
            let erudaUrl = CDN + '/s17/lib/eruda/1.5.8/seed.min.js';
            if (erudaUrl) {
                let scriptElement = document.createElement('script');
                scriptElement.type = 'text/javaScript';
                scriptElement.charset = 'utf-8';
                scriptElement.async = true;
                scriptElement.src = `${erudaUrl}`;
                scriptElement.addEventListener('load', function () {
                    try {
                        window.eruda.init();
                    } catch (e) {
                        console.log(e);
                    }
                    func();
                });
                document.head.appendChild(scriptElement);
            } else {
                func();
            }
        } else {
            func();
        }
    } catch (e) {
        func();
    }
};
export const _$isAppEnv = (initParam, func) => {
    //appParams可传可不传 是否是App内打开
    let ua = window.navigator.userAgent;
    let val = initParam ? initParam.client_name : ua;
    if (typeof func === 'function') {
        let scene = null;
        if (/17Parent/i.test(val)) {
            scene = 'parent';
        } else if (/17Student/i.test(val)) {
            scene = 'student';
        } else if (/17Teacher/i.test(val)) {
            scene = 'teacher';
        } else if (/17JuniorStu/i.test(val)) {
            scene = 'JuniorStudent';
        } else if (/17JuniorTea/i.test(val)) {
            scene = 'JuniorTeacher';
        } else if (/17JinShuParent/i.test(val)) {
            // 家长通
            scene = 'jinshuparent';
        } else if (/17zuoyeBox/i.test(val)) {
            // 盒子
            scene = '17zuoyebox';
        } else if (/YQSaasTeacher/i.test(val)) {
            // 一教一学
            scene = 'yqsaasteacher';
        } else if (/YQSaasMinZhi/i.test(val)) {
            // 闵行独立客户端
            scene = 'yqsaasminzhi';
        } else {
            scene = null;
        }
        return func(scene);
    } else {
        if (/17Parent/i.test(val)) {
            return 'parent';
        } else if (/17Student/i.test(val)) {
            return 'student';
        } else if (/17Teacher/i.test(val)) {
            return 'teacher';
        } else if (/17JuniorStu/i.test(val)) {
            return 'JuniorStudent';
        } else if (/17JuniorTea/i.test(val)) {
            return 'JuniorTeacher';
        } else if (/17JinShuParent/i.test(val)) {
            // 家长通
            return 'jinshuparent';
        } else if (/17zuoyeBox/i.test(val)) {
            // 盒子
            return '17zuoyebox';
        } else if (/YQSaasTeacher/i.test(val)) {
            // 一教一学
            return 'yqsaasteacher';
        } else if (/YQSaasMinZhi/i.test(val)) {
            // 闵行独立客户端
            return 'yqsaasminzhi';
        } else {
            return false;
        }
    }
};
export function getAppVersion(callback) {
    var native_version = "";
    var _ua = window.navigator && window.navigator.userAgent;
    var _nv = function(){
        check_external("getInitParams", function (exists) {
            if (exists) {
                do_external('getInitParams', function (res) {
                    native_version = res.native_version;
                    callback && callback(native_version);
                });
            }
        });
    };

    if (_ua) {
        try{
            const reg = /\d+\.\d+\.\d+\.\d+/g;
            const verArr = _ua.match(reg) || [];
            verArr.reverse();
            native_version = verArr[0] || '';
            callback && callback(native_version);
        }catch (e) { console.info(e) }
        const reg = /^[0-9]+/;
        if (!native_version || !reg.test(native_version)) {
            if(/android/i.test(ua)) {
                _nv();
            } else {
                native_version = getQuery('app_version') || '3.2.2';
            }
        };
        // !native_version && _nv();
    } else {
        _nv();
    }
    return native_version;
}
//获得地址栏参数
function getQuery(item, url) {
    if(item){
        var svalue = (url || location.search).match(new RegExp('[\?\&]' + item + '=([^\&]*)(\&?)', 'i'));
        return svalue ? decodeURIComponent(svalue[1]) : '';
    } else {
        return decodeLocationSearch(url);
    }
}
export function versionCompare(src, dest) {
    if (typeof src + typeof dest !== "stringstring") {
        return false;
      }
    
      const src_arr = src.split("."),
        dest_arr = dest.split("."),
        len = Math.max(src_arr.length, dest_arr.length);
    
      // eslint-disable-next-line complexity
      for (let index = 0; index < len; index += 1) {
        const src_cache = parseInt(src_arr[index], 0),
          dest_cache = parseInt(dest_arr[index], 0);
    
        if ((src_cache && !dest_cache && src_cache > 0) || src_cache > dest_cache) {
          return 1;
        }
        if (
          (dest_cache && !src_cache && dest_cache > 0) ||
          src_cache < dest_cache
        ) {
          return -1;
        }
      }
    
      return 0;
}
export const _$updateTitle = (txt) => {
    do_external('updateTitle', txt, '', '', () => {
        document.title = txt;
    });
    document.title = txt;
};

export const _$windowFontSize = () => {
    function FontSize() {
        let clientWidth =
            document.documentElement.clientWidth < document.documentElement.clientHeight
                ? document.documentElement.clientWidth
                : navigator.userAgent.indexOf('17zuoyeBox') > -1
                ? 375
                : document.documentElement.clientHeight;
        let deviceWidth = clientWidth > 750 ? 750 : clientWidth;
        //按照750像素下字体为 100px的标准来, 共 7.5rem
        document.documentElement.style.fontSize = deviceWidth / 7.5 + 'px';
    }
    FontSize();
    //window.onload = FontSize;
    window.onresize = FontSize;
};
/**
 * 通过文件路径获取文件名
 * @param path
 * @returns {*}
 */
export const getFileName = (path) => {
    return path.replace(/(.*\/)*([^.]+).*/gi, '$2');
};
//毫秒转换时间
export const millisecondToDate = (millisecond) => {
    // 不足1s按1s处理
    // millisecond = millisecond < 1000 ? 1000 : millisecond;
    if (millisecond === null || millisecond === undefined) {
        return '-';
    }
    let hours = millisecond / 1000 / 60 / 60;
    let hoursRound = Math.floor(hours);
    let minutes = millisecond / 1000 / 60 - 60 * hoursRound;
    let minutesRound = Math.floor(minutes);
    let seconds = millisecond / 1000 - 60 * 60 * hoursRound - 60 * minutesRound;
    let secondsRound = Math.ceil(seconds);
    const isShow = (val, unit) => {
        return val > 0 ? `${val}${unit}` : '';
    };
    return `${isShow(hoursRound, '时')}${isShow(minutesRound, '分')}${secondsRound}秒`;
};
export const getCookie = (name) => {
    let arr,
        reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    if ((arr = document.cookie.match(reg))) {
        return unescape(arr[2]);
    } else {
        return null;
    }
};

export const getUrlParam = (url) => {
    let _url = url === null || url === void 0 ? void 0 : url.split('?');

    let result = {};

    if ((_url === null || _url === void 0 ? void 0 : _url.length) > 1) {
        let reg = new RegExp(/(?:^|&)(\w+?)=([^&]+)/gi);

        let _result;
        /* eslint-disable-next-line no-cond-assign */

        while ((_result = reg.exec(_url[1]))) {
            let _result2;

            if (
                ((_result2 = _result) === null || _result2 === void 0 ? void 0 : _result2.length) >
                2
            ) {
                result[_result[1]] = _result[2];
            }
        }
    }

    return result;
};
export const webpToJpg = (url) =>
    url.indexOf('x-oss-process=image') >= 0
        ? url + '/format,jpg'
        : url + (url.indexOf('?') >= 0 ? '&' : '?') + 'x-oss-process=image/format,jpg';
export const ossCropImage = function (image, coordinateOrigin) {
    let scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    let others = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    let coordinate = JSON.parse(JSON.stringify(coordinateOrigin));
    coordinate = coordinate.map((_c) => {
        let getScale = (value) => {
            let v = (value * scale).toString();
            return parseInt(v);
        };

        _c['x'] = getScale(_c['x']);
        _c['y'] = getScale(_c['y']);
        return _c;
    });
    let imgParam = getUrlParam(image);
    let urlSymbol = (image || '').indexOf('?') >= 0 ? '&' : '?';
    let imgCut = ''
        .concat(image)
        .concat(imgParam['x-oss-process'] ? '' : urlSymbol + 'x-oss-process=image', '/crop,x_')
        .concat(coordinate[0].x, ',y_')
        .concat(coordinate[0].y, ',w_')
        .concat(coordinate[2].x - coordinate[0].x, ',h_')
        .concat(coordinate[2].y - coordinate[0].y)
        .concat(others);
    return imgCut;
};
